import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as fromUploader from '@app/client/uploader/store/reducers';
import * as fromRoot from '@app/reducers';
import { Promotion } from '@app/shared/models/promotion';
import { DialogRef, DialogService } from '@ngneat/dialog';
import { select, Store } from '@ngrx/store';
import { GoogleTagManagerService } from '@app/core/lib/google-tag-manager/angular-google-tag-manager.service';
import { Observable } from 'rxjs';
import { Constant } from 'src/constant';
import { ModalPromotionForbiddenComponent } from '../modal-promotion-forbidden/modal-promotion-forbidden.component';
import { PrepareActions } from '@app/client/uploader/store/actions';


@Component({
  selector: 'app-modal-promotion',
  templateUrl: './modal-promotion.component.html',
  styleUrls: ['./modal-promotion.component.scss'],
  animations: [
    trigger('animateHeader', [
      state('in', style({ transform: 'translateX({{startPosition}})' }), { params: { startPosition: '0px' } }),
      state('out', style({ transform: 'translateX({{endPosition}})' }), { params: { endPosition: '-355px' } }),
      transition('in => out', animate('0.4s ease-in-out')),
      transition('out => in', animate('0.4s linear'))
    ]),
    trigger('loader', [
      state('in', style({ opacity: '{{startOpacity}}', transform: 'translateX({{onPosition}})' }), { params: { startOpacity: '0.9', onPosition: '0%' } }),
      state('out', style({ opacity: '{{endOpacity}}', transform: 'translateX({{offPosition}})' }), { params: { endOpacity: '0', offPosition: '100%' } }),
      transition('in => out', animate('0.4s ease-in-out')),
      transition('out => in', animate('0.4s linear'))
    ]),
  ],
})
export class ModalPromotionComponent implements OnDestroy {

  promotions$: Observable<Promotion[]>;
  selectedPromotion$: Observable<Promotion>;

  selected: any;
  promotionForm: FormGroup;
  selectedMedia: any;
  medias: any[];
  replay = false;
  timer: any;
  freemiumModalOpened = false;
  isLoading = false;
  state = 'loadingNotStarted';
  isSaveLoading = false;
  hasItemSelected = false;
  actionsExpanded = false;
  hasError = false;
  isFreemium$: Observable<any>;

  constructor(
    private store: Store<fromRoot.State & fromUploader.State>,
    public ref: DialogRef,
    public dialog: DialogService,
    public gtmService: GoogleTagManagerService,
  ) {
    // list promotions
    this.promotions$ = this.store.pipe(select(fromUploader.getExternalPromotions));
    this.selectedPromotion$ = this.store.pipe(select(fromUploader.getExternalPromotionSelected));

    this.store.select(fromUploader.getExternalPromotionSelected).subscribe(promotion => {
      this.selected = promotion;
      if (promotion) {
        this.onReplay();
        this.medias = promotion.medias;
        if (this.medias && this.medias.length) {
          this.selectMedia(this.medias[0]);
        }
      }
    });

    this.isFreemium$ = this.store.pipe(select(fromRoot.getIsFreemium));
  }

  ngOnDestroy() {
    // this.ref.close();
  }

  onAddPromotion(): void {
    this.dialog.open(ModalPromotionForbiddenComponent, {
      closeButton: false,
      enableClose: true,
      size: 'sm',
    });
    this.gtmService.pushTag({
      event: Constant.eventGTM.CLICK_ADD_PROMOTION_FREEMIUM
    });
  }

  closeFreemiumModal() {
    this.freemiumModalOpened = false;
  }

  onSelectPromotion(promotion) {
    this.hasItemSelected = true;
    this.store.dispatch(PrepareActions.loadPromotion({ promotion }));
    this.store.dispatch(PrepareActions.SetTransferPromotion({ promotion }));
  }

  onReplay($event = null) {
    if ($event) {
      $event.stopPropagation();
    }
    this.replay = false;
    this.replay = true;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.replay = false;
    }, 3000);
  }

  selectMedia(media) {
    if (media) {
      const index = media.id ? this.medias.findIndex(_media => media.id === _media.id) : this.medias.findIndex(_media => media.object_id === _media.object_id);
      this.selectedMedia = { ...media, index };
    } else {
      return null;
    }
  }

  isMediaSelected(media: any) {
    if (this.selectedMedia) {
      return media.id === this.selectedMedia.id;
    }
  }

  get indexSelected() {
    return this.selectedMedia ? this.selectedMedia.index : null;
  }

  onToggleActionList(event): void {
    event.stopPropagation();
    this.actionsExpanded = !this.actionsExpanded;
  }

  isSelected(promotion): boolean {
    return promotion.selected;
  }

  onPreview(media) {
    this.selectedMedia = media;
  }

  resolveSrcUrlString(src: string): string {
    const srcUrlString = `url(${src})`;
    return srcUrlString;
  }

  @HostListener('document:click')
  clickout() {
    this.actionsExpanded = false;
  }
}




